type ToggleIndexAction = {
  type: "toggle_index";
  payload: number;
};
export type UserScheduleAccordionActions = ToggleIndexAction;

export type UserScheduleAccordionState = {
  openIndexes: number[];
};

export const initialUserScheduleAccordionState: UserScheduleAccordionState = {
  openIndexes: [],
};

export const userScheduleAccordionReducer = (
  state: UserScheduleAccordionState = initialUserScheduleAccordionState,
  action: UserScheduleAccordionActions
) => {
  if (action.type === "toggle_index") {
    const closing = state.openIndexes.includes(action.payload);
    return closing
      ? {openIndexes: state.openIndexes.filter((i) => i !== action.payload)}
      : {...state, openIndexes: [...state.openIndexes, action.payload]};
  }
  return state;
};
